export const usernameRegex = /^[a-zA-Z\d]{4,}$/
export const workspaceRegex = /^[-_ a-zA-Z\d]{4,}$/
export const codeRegex = /^[A-Z\d]{16}$/
export const pwdRegex = /^[a-zA-Z\d]{6,}$/
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;